import { com } from '@eidu/form'
import { useContext, useMemo } from 'react'
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce'
import { useQuery } from '@tanstack/react-query'
import { createAuthContext } from '../api/authorization/AuthenticationContext'
import { requireNotUndefinedOrNull } from '../util/require'
import getEntityCount from '../api/entity/data/getEntityCount'
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

type UseEntityCountParams = {
  typeId: EntityTypeId
  searchQuery?: string
}

const useEntityCount = ({ typeId, searchQuery }: UseEntityCountParams): number | undefined => {
  const iAuthContext = useContext<IAuthContext>(AuthContext)
  const authContext = useMemo(
    () => createAuthContext(iAuthContext),
    [iAuthContext.token, iAuthContext.idTokenData?.organizationId]
  )

  const query = useQuery({
    queryKey: ['entityCount', typeId.toString(), searchQuery ?? ''],
    queryFn: async ({ signal }: { signal: AbortSignal }) => {
      return getEntityCount({
        typeId,
        query: searchQuery,
        authContext: requireNotUndefinedOrNull(authContext),
        signal,
      })
    },
    enabled: !!authContext,
  })

  return query.data
}

export default useEntityCount
